import get from 'lodash/get';

export const getState = (state, param = null, defaultValue = null) => get(state, `notes${(param ? `.${param}` : '')}`, defaultValue);
